import { FC } from 'react';
import { Button } from 'antd';
import { TbLock } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { useReportComponentAccess } from '@/hooks/useNestedResourceAccess';
import { useReportComponentStore } from '@/stores';
import { ReportComponent } from '@/types';

import SmallTooltip from '../../tooltips/SmallTooltip';

interface ReportComponentLockButtonProps {
    component: ReportComponent;
}

const ReportComponentLockButton: FC<ReportComponentLockButtonProps> = ({ component }) => {
    const { token } = useAntDesignTheme();
    const reportAccess = useReportComponentAccess(component);
    const toggleReportComponentLock = useReportComponentStore((state) => state.toggleReportComponentLock);

    if (!component.locked) {
        return null;
    }

    const canUnlock = reportAccess.canUpdate;

    return (
        <SmallTooltip
            title={canUnlock ? 'Unlock Component' : 'This Component is Locked'}
            placement='topRight'
            padding='0.5rem 0'
        >
            <Button
                aria-label={canUnlock ? 'Unlock Component' : 'Locked Component'}
                disabled={!canUnlock}
                onClick={() => void toggleReportComponentLock(component.id, false)}
                size='small'
            >
                <TbLock style={{ color: token.colorTextTertiary }} />
            </Button>
        </SmallTooltip>
    );
};

export default ReportComponentLockButton;
